<h3 mat-dialog-title>Alterar Cotação do Ativo</h3>
<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Setor</mat-label>
                <mat-select 
                    placeholder="Setor"                    
                    [formControl]="setor_id"
                    required
                    name="setor"                    
                >
                     <mat-option value="">SELECIONE</mat-option>
                    <mat-option *ngFor="let setor of listSetor" [value]="setor.id">{{setor.nome}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerSetor"></mat-spinner>
                <mat-error *ngIf="setor_id.invalid">{{getErrorSetorMessage()}}</mat-error>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>Tipo</mat-label>
                <mat-select
                    [formControl]="tipo"
                    name="tipo"                    
                    (selectionChange)="checaOpcao($event)"
                >
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option value="NORMAL">BOVESPA</mat-option>
                    <mat-option value="OPCAO">OPÇÃO</mat-option>
                    <mat-option value="FIIs">FIIs</mat-option>
                    <mat-option value="FRACIONARIO">FRACIONARIO</mat-option>
                    <mat-option value="INDICE">ÍNDICE</mat-option>
                    <mat-option value="SUBSCRICAO">SUBSCRIÇÃO</mat-option>
                    <mat-option value="BDR">BDR</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100%" *ngIf='habilitaTipoOpcao'>
            <mat-form-field  appearance="outline" fxFlex="50">
                <mat-label>Tipo Opção</mat-label>
                <mat-select                     
                    [formControl]="tipo_opcao"
                    name="tipo_opcao">
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option value="CALL">CALL</mat-option>
                    <mat-option value="PUT">PUT</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field style="width: 50%; margin-left: 10px;"  appearance="outline" fxFlex="50">
                <mat-label>Mês de Vencimento</mat-label>
                <input 
                    matInput                     
                    [formControl]="mesVencimento"                    
                    type="number"
                    maxlength="2"> 
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100%" appearance="outline" fxFlex="100">
            <mat-form-field style="width: 50%"  appearance="outline" fxFlex="50">
                <mat-label>Nome</mat-label>
                <input 
                    matInput 
                    placeholder="Nome" 
                    [formControl]="nome" 
                    [readonly] = readonlyFields
                    required
                    maxlength="255">                
            </mat-form-field>

            <mat-form-field style="width: 50%; margin-left: 10px;"  appearance="outline" fxFlex="50">
                <mat-label>Ticker</mat-label>
                <input 
                    matInput 
                    placeholder="Sigla" 
                    [formControl]="sigla" 
                    [readonly] = readonlyFields
                    required
                    maxlength="10">                    
            </mat-form-field>
        </div>
        <div fxFlex.gt-sm="100%" appearance="outline" fxFlex="100">
            <mat-form-field style="width: 100%"  appearance="outline" fxFlex="100">
                <mat-label>Última Cotação</mat-label>
                <input 
                    matInput 
                    placeholder="Valor (R$)" 
                    [formControl]="valor" 
                    required
                    maxlength="255"
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">                    
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100%" appearance="outline" fxFlex="100">
            <mat-radio-group [formControl]="bovespa" >
                <mat-label>Atualiza Cotação RT ?</mat-label><br/>
                <mat-radio-button value="true" class="py-8" style="margin-right: 10px;">
                    <div fxLayout="row" fxLayoutAlign="start center">                        
                        <span class="mat-h4 m-0">SIM</span>
                    </div>
                </mat-radio-button>
                <mat-radio-button value="false" class="py-8">
                    <div fxLayout="row" fxLayoutAlign="start center">                        
                        <span class="mat-h4 m-0">NÃO</span>
                    </div>
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1"
    >   Salvar
    </button>
</div>